import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { Stats } from "@/components/portfolio/Stats";
import { Services } from "@/components/portfolio/Services";
import { About } from "@/components/portfolio/About";
import { Experience } from "@/components/portfolio/Experience";
import { Education } from "@/components/portfolio/Education";
import { Contact } from "@/components/portfolio/Contact";
import { Footer } from "@/components/portfolio/Footer";
import { WhatsAppFloat } from "@/components/portfolio/WhatsAppFloat";
import { ReelModal } from "@/components/portfolio/ReelModal";

function App() {
  const [reelOpen, setReelOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <Nav onOpenReel={() => setReelOpen(true)} />
        <main>
          <Hero />
          <Stats />
          <Services />
          <About />
          <Experience />
          <Education />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <ReelModal open={reelOpen} onClose={() => setReelOpen(false)} />
      </div>
    </LanguageProvider>
  );
}

export default App;
